module.exports = __webpack_public_path__ + "static/media/p35.92f9c3bd.jpg";